import React from "react";
import { useNavigate } from "react-router-dom";

function Organizationselect(){

    let navigate = useNavigate();

    async function handleChange(event) {
      //console.log(event.target.value)
      localStorage.setItem("orgId", event.target.value);
      let index = event.nativeEvent.target.selectedIndex;
      localStorage.setItem("orgName", event.nativeEvent.target[index].text);
      event.preventDefault();
      navigate("/Landing");
      window.location.reload(true);
    }

    return (
        <div className="row justify-content-md-center">
            <div className="col col-lg-4">
                <div className="card mt-5 pb-3">
                    <div className="card-body">
                        <h5 className="mt-5 mb-3 fw-bold text-lg-center">Welcome to CareIO</h5>
                        <p className="px-2 text-lg-center">By selecting this you can access appointments, upload, imaging study & many actions related to the organization.</p>
                        <div className="row justify-content-md-center">
                            <div className="col col-lg-7 mb-5">
                                <label className="fw-bold form-label">Organization</label>
                                <select className="form-select" aria-label="Default select example" onChange={handleChange}>
                                    <option value="">Select organization</option>
                                    <option value="3732341f-4725-4f9e-b848-daad66a02741">123 Health Plan</option>
                                    <option value="f058c564-eb39-4c92-b13a-abfa2e8e86f2">My Health Records</option>
                                    <option value="76014e66-f7c5-49ba-b176-2dbf462975d0">Akumin</option>
                                    <option value="8975b1f8-a44c-4c50-80ef-ac63770624ad">Allied Healthcare</option>
                                    <option value="be477978-e1f2-4ac6-8ec2-6c86e17df4d9">Atlantic Medical Imaging</option>
                                    <option value="e8fed5a8-6e57-4d23-9801-ebedf7302e27">Genex Seattle</option>
                                    <option value="5b3b1090-fcb9-49c1-a4bf-204c86736028">Genex Winchester</option>
                                    <option value="4243f7d8-198e-4e42-bb8c-e4ca8e6bbd0e">Main Street Radiology</option>
                                    <option value="2973b0aa-5294-49d2-a978-3dd017ce519e">Medical Consultants Network</option>
                                    <option value="33f032d7-ff2a-4646-902e-389db72dd778">One Call Care Management</option>
                                    <option value="634fbfd8-df08-44b6-8a78-bcabf4e1c0b0">RadNet Arizona</option>
                                    <option value="9bc13675-d0b9-4be8-b60f-6b28f4084645">RadNet Florida</option>
                                    <option value="7207cd31-b393-48a0-8431-e18277bbbe15">RadNet Mid Atlantic</option>
                                    <option value="686b1b12-983b-4992-8f2d-f5676eb7fcc7">RadNet North East</option>
                                    <option value="64bd5464-47dc-4cc7-b8f3-83f29bda0e6a">RadNet West Coast</option>
                                    <option value="ead79671-ce66-44e9-90ba-83ef4bdc8ad7">SimonMed</option>
                                    <option value="7166c18d-13ce-419e-87ff-2156d839440f">Zwanger-Pesiri Radiology</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Organizationselect;